import config from '../../config'

const getResponses = ({ airportId, workOrderId = 0, activeOnly = true }) => ({
method: 'get',
  url: `${config.baseUrl}/${airportId}/SafetyItemResponses/WorkOrder/${workOrderId}?&activeOnly=${activeOnly}`,
})

export default getResponses
